const CLEAR_COMMON_STATE = 'CLEAR_COMMON_STATE';

// Spinner
const START_SPINNER = 'START_SPINNER';
const STOP_SPINNER = 'STOP_SPINNER';

export const spinnerActionTypes = {
    START_SPINNER,
    STOP_SPINNER,
    CLEAR_COMMON_STATE
};

// Progress Bar
const FILE_PROCESSING = 'FILE_PROCESSING';
const FILE_PROCESSED = 'FILE_PROCESSED';
export const progressActionTypes = {
    FILE_PROCESSING,
    FILE_PROCESSED,
};

// Ping action types
const SET_PING_STATUS = 'SET_PING_STATUS';
export const pingStatusActionTypes = {
    SET_PING_STATUS,
    CLEAR_COMMON_STATE
};

//Get Counties for selected ZipCode
const SET_COUNTY_DATA = 'SET_COUNTY_DATA';
const CLEAR_COUNTY_DATA = 'CLEAR_COUNTY_DATA';
export const zipCodeActionTypes = {
    SET_COUNTY_DATA,
    CLEAR_COUNTY_DATA,
    CLEAR_COMMON_STATE
};




// Environment
const SET_ENVIRONMENTS = 'SET_ENVIRONMENTS';
const CHANGE_LANG = 'CHANGE_LANG';
const UPDATE_EXPLAINER_DATA = 'UPDATE_EXPLAINER_DATA';
const UPDATE_ICON_UNREAD_COUNT = 'UPDATE_ICON_UNREAD_COUNT';
const UPDATE_PROP = 'UPDATE_PROP';
const INCREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT = 'INCREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT';
const DECREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT = 'DECREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT';
const UPDATE_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT = 'UPDATE_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT';

export const unreadMailActionTypes = {
    CLEAR_COMMON_STATE,
    UPDATE_ICON_UNREAD_COUNT
};

export const environmentActionTypes = {
    SET_ENVIRONMENTS,
    CHANGE_LANG,
    UPDATE_EXPLAINER_DATA,
    UPDATE_ICON_UNREAD_COUNT,
    UPDATE_PROP,
    CLEAR_COMMON_STATE,
    INCREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT,
    DECREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT,
    UPDATE_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT,
};

// Error
const SET_ERROR = 'SET_ERROR';
const REMOVE_ERROR = 'REMOVE_ERROR';

export const errorActionTypes = {
    SET_ERROR,
    REMOVE_ERROR,
    CLEAR_COMMON_STATE
};

// Messages
const SET_MESSAGES = 'SET_MESSAGES';
const SET_LOADED_MESSAGES = 'SET_LOADED_MESSAGES';

export const messagesActionTypes = {
    SET_LOADED_MESSAGES,
    SET_MESSAGES,
    CLEAR_COMMON_STATE
};

// Modal action types

const SHOW_MODAL = 'SHOW_MODAL';
const HIDE_MODAL = 'HIDE_MODAL';
const HIDE_ALL_MODALS = 'HIDE_ALL_MODALS';

export const modalActionTypes = {
    SHOW_MODAL,
    HIDE_MODAL,
    HIDE_ALL_MODALS
};

// commonSagaActionTypes

const GET_ENVIRONMENT = 'GET_ENVIRONMENT';

export const commonSagaActionTypes = {
    GET_ENVIRONMENT
};